const orgSettingsCopy = {
  homeCurrencyLabel: 'Home Currency',
  marketDataSourceLabel: 'Market Data Source',
  orgNameLabel: 'Name',
  timeZoneLabel: 'Time Zone'
};

export default orgSettingsCopy;
